import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { ReleasePosValidationSchema } from "../pages/Show/schemas/releasePos.schema"

interface UseUnblockPosModalProps {
  id?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useReleasePos = ({ id, onSuccess, onError }: UseUnblockPosModalProps) => {
  const privateAxios = usePrivateAxios()
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['releasePos', id],
    mutationFn: async (data: ReleasePosValidationSchema) => {
    await privateAxios.put(`/pos/machines/${id}/release`, {
        pos: {
         release_reason: data.description,
        }
      })
    },
    onSuccess: () => {
      if (id) {
        queryClient.invalidateQueries({queryKey: ["posMachineById", id]});
      }
      onSuccess?.();
    },
    onError,
  })
}